import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { ButtonTertiary } from '@spotify-internal/encore-web';
import theme from 'lib/theme';
import * as tokens from 'styles';

export const linkColor = theme({
  fallback: tokens.black,
  duoLight: tokens.black,
  duoDark: tokens.black,
  familyLight: tokens.royalBlue,
  familyDark: tokens.black,
});

const Button = styled(ButtonTertiary)`
  color: ${linkColor} !important;
  padding: 0;
  cursor: pointer;
  color: inherit;
  text-transform: none;
  font-weight: 500;
  text-decoration: underline;
  letter-spacing: 0;
  font-size: 16px;
  border-radius: 0;

  &:focus {
    box-shadow: 0 3px 0 0 #181818;
    text-decoration: none;

    &:after {
      border: 0;
    }
  }
`;

type UnderlinedProps = ComponentProps<typeof ButtonTertiary>;

const Underlined = ({ children, ...props }: UnderlinedProps) => (
  <Button {...props}>{children}</Button>
);

export default Underlined;
